var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { saveAs } from "file-saver";
import { addStrokesOnPage } from "./addStrokesOnPage";
import { getSOBPListForSave } from "./getSobpList";
import { generateBasePdf } from "./makePdfDocument";
export function savePDF(saveName, options, externalStrokes) {
    return __awaiter(this, void 0, void 0, function* () {
        let { sobps } = options;
        if (!sobps) {
            // sobps가 주어지지 않으면, options에 따라서 sobp 집합을 가져온다.
            sobps = getSOBPListForSave(options || {});
        }
        const filename = saveName;
        const pdfDoc = yield generateBasePdf(sobps);
        const { surfaceOwnerIds } = options || {};
        addStrokesOnPage(pdfDoc, sobps, surfaceOwnerIds, externalStrokes);
        const pdfBytes = yield pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        saveAs(blob, filename);
        // firebaseAnalytics.logEvent('save_pdf', { event_name: 'save_pdf' });
        return sobps;
    });
}
//# sourceMappingURL=SavePdf.js.map